import { render, staticRenderFns } from "./AffiliateToolbar.vue?vue&type=template&id=5a612b6f&"
import script from "./AffiliateToolbar.vue?vue&type=script&lang=js&"
export * from "./AffiliateToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports